import { CSSObject } from '@emotion/react';
import { TDot, TDotContainer } from './Carousel.styles';

export const Dot = ({ selected }: TDot): CSSObject => ({
  bg: selected ? 'beta.500' : 'blackAlpha.600',
  mt: '1',
});

export const DotContainer = ({
  numberOfSlides,
  index,
}: TDotContainer): CSSObject => ({
  bgGradient: 'linear(to-b, alpha.400, alpha.600)',
  borderLeftRadius: index === 0 ? '12' : '0',
  pl: index === 0 ? '0.5' : '0',
  borderRightRadius: index === numberOfSlides - 1 ? '12' : '0',
  pr: index === numberOfSlides - 1 ? '0.5' : '0',
});

export const CarouselWrapper: CSSObject = {
  '& .control-dots ': {
    bottom: '0',
    marginY: 'px',
  },
  '& .carousel .slider-wrapper ': {
    w: ['99%', null, '810px'],
  },
};
